class ProductVariantAtc {
  constructor () {
    this.setupListeners()
  }

  setupListeners () {
    document.addEventListener('click', this.handleDocumentClick.bind(this))
  }

  async handleDocumentClick (e) {
    const button = e.target?.closest('[data-product-variant-atc-el="button"]')
    if (!button) return

    const variantId = button.getAttribute('data-variant-id')
    if (variantId) {
      await this.addVariantToCart(variantId)
    }
  }

  async addVariantToCart (variantId) {
    try {
      const button = document.querySelector(
        `[data-product-variant-atc-el="button"][data-variant-id="${variantId}"]`,
      )

      const properties = {}

      const preOrderDate = button?.getAttribute('data-variant-pre-order')
      const startDate = button?.getAttribute('data-variant-start-date')

      if (preOrderDate) {
        properties._preorder = 'true'
        properties[
          window.theme?.strings?.estimated_dispatch || 'Pre-order'
        ] = preOrderDate
      }

      if (startDate) {
        properties._start_date = startDate
      }

      window.BAO.Cart.addItem({
        id: parseInt(variantId),
        quantity: 1,
        ...(Object.keys(properties).length ? { properties } : {}),
      })
    } catch (error) {
      console.error('Error adding variant:', error)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.BAO.productVariantAtc = new ProductVariantAtc()
})
